import React from 'react'

interface ReviewCommentCountProps {
  commentCount: number
  onClick?: () => void
}

const ReviewCommentCount: React.FC<ReviewCommentCountProps> = ({
  commentCount,
  onClick,
}) => {
  return (
    <div
      className={`flex items-center gap-8px ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <img
        src="/images/comment-bold.png"
        alt="댓글"
        className="w-20px h-20px"
      />
      {commentCount > 0 && (
        <span className="text-style-button2 text-textColorText2 text-left leading-none">
          {commentCount}
        </span>
      )}
    </div>
  )
}

export default ReviewCommentCount
